import React from 'react';
import PropTypes from 'prop-types';

import {useComponent} from './hooks/useComponent';

import '../SearchDay/SearchDay.less';
import './SearchStandardDay.less';

function SearchStandardDay(props) {
    const {
        className,
        contentClassName,
        labelClassName,
        valueClassName,
        day,
        ariaLabelDate
    } = useComponent(props);

    return (
        <div className={className} aria-hidden>
            <dl className={contentClassName}>
                <dt className={labelClassName}>
                    {day}
                </dt>
                <dd className={valueClassName}>
                    {ariaLabelDate}
                </dd>
            </dl>
        </div>
    );
}

SearchStandardDay.propTypes = {
    ariaLabelDate: PropTypes.string,
    dateString: PropTypes.string,
    day: PropTypes.number,
    isPast: PropTypes.bool,
    isToday: PropTypes.bool
};

SearchStandardDay.defaultProps = {
    ariaLabelDate: '',
    dateString: '',
    day: 0,
    isPast: false,
    isToday: false
};

SearchStandardDay.canClick = function canClick(props) {
    const {
        dayData: {
            inPast
        },
        isPast
    } = props;

    return !(isPast || inPast);
};

// SearchStandardDay.whyDidYouRender = true;

export {SearchStandardDay};
